<template>
  <!-- Add Designation Modal -->
  <div
    id="add_designation"
    class="modal custom-modal fade"
    role="dialog"
    ref="addDesignationModal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Position</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="adddesgclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onSubmit">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Position Name <span class="text-danger">*</span></label
              >
              <!-- <input class="form-control" type="text" /> -->

              <Field
                name="designation_name"
                type="text"
                class="form-control"
                v-model="form.designation_name"
                :class="{
                  'is-invalid': error?.designation_name
                    ? error.designation_name[0]
                    : '',
                }"
              />
              <div class="invalid-feedback">
                {{ error?.designation_name ? error.designation_name[0] : "" }}
              </div>
              <div
                class="designation_nameshow text-danger"
                id="designation_name"
              ></div>
            </div>
            <div class="input-block mb-3">
              <div class="form-check" style="padding-left: 0px">
                <label
                  class="form-check-label"
                  for="customCheck2"
                  style="margin-left: 5px"
                  >Is Reporter ?
                </label>
                <input
                  name="is_reporter"
                  type="checkbox"
                  class="days recurring"
                  id="customCheck2"
                  :value="1"
                  v-model="form.is_reporter"
                  :checked="form.is_reporter"
                  style="margin-left: 10px"
                />
                <div class="invalid-feedback">
                  {{ error?.is_reporter ? error.is_reporter[0] : "" }}
                </div>
                <div class="is_reportershow text-danger" id="is_reporter"></div>
              </div>
            </div>
            <!--
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Department <span class="text-danger">*</span></label
              >
			  <Field
                    name="department"
                    as="select"
                    class="form-control"
					v-model="form.department"
					:class="{ 'is-invalid': errors.department }"
                  >
				  <option value="">Select Department</option>
				  <option v-for="department in departmentlist" :key="department.id" :value="department.id">{{ department.name }}</option>
				  <div class="invalid-feedback">{{ errors.department }}</div>
                  <div class="departmentshow text-danger" id="department"></div>
			  </Field>
              
            </div> -->
            <div class="input-block mb-3">
              <div class="form-check" style="padding-left: 0px">
                <label
                  class="form-check-label"
                  for="customCheck3"
                  style="margin-left: 5px"
                  >{{ selectAllPermission ? "Deselect All" : "Select All" }}
                </label>
                <input
                  type="checkbox"
                  class="days recurring"
                  id="customCheck3"
                  :value="1"
                  v-model="selectAllPermission"
                  :checked="selectAllPermission"
                  style="margin-left: 10px"
                  @change="handleSelectAllPermission"
                />
              </div>
            </div>
            <div class="">
              <table class="table table-striped custom-table">
                <thead>
                  <tr>
                    <th>Module Permission</th>
                    <!-- <th class="text-center">Show Navbar</th> -->
                    <th class="text-center">Read</th>
                    <th class="text-center">Edit/Update</th>
                    <th class="text-center">Create</th>
                    <th class="text-center">Delete</th>
                    <th class="text-center">Import</th>
                    <th class="text-center">Export</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Holiday</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.holiday.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.holiday.read"
                          @change="handlePermissionChangeForRead('holiday')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.write"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.create"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.delete"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.import"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.export"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Employee</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.employee.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.employee.read"
                          @change="handlePermissionChangeForRead('employee')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.write"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.create"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.delete"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.import"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.export"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Face Recognization</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.face_recognization.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.face_recognization.read"
                          @change="
                            handlePermissionChangeForRead('face_recognization')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.write"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.create"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.delete"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.import"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.export"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Employee BGV</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.emp_bgv.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.emp_bgv.read"
                          @change="handlePermissionChangeForRead('emp_bgv')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.write"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.create"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.delete"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.import"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.export"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Admin Attendance</td>
                    <!-- <td class="text-center">
                        <label class="custom_check">
                          <input type="checkbox"
                          name="rememberme"
                          class="rememberme" v-model="permissions.admin_attendance.show_navbar" />
                          <span class="checkmark"></span>
                        </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.read"
                          @change="
                            handlePermissionChangeForRead('admin_attendance')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.write"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.create"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.delete"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.import"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.export"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Attendance</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox"
                        name="rememberme"
                        class="rememberme" v-model="permissions.attendance.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.read"
                          @change="handlePermissionChangeForRead('attendance')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.write"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.create"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.delete"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.import"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.export"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Department</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.department.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.department.read"
                          @change="handlePermissionChangeForRead('department')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.write"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.create"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.delete"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.import"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.export"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Position</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.designation.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.designation.read"
                          @change="handlePermissionChangeForRead('designation')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.write"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.create"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.delete"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.import"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.export"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Wages</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.wages.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.wages.read"
                          @change="handlePermissionChangeForRead('wages')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.write"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.create"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.delete"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.import"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.export"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Payslip</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.payslip.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.payslip.read"
                          @change="handlePermissionChangeForRead('payslip')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.write"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.create"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.delete"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.import"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.export"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Schedule</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.schedule.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.schedule.read"
                          @change="handlePermissionChangeForRead('schedule')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.write"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.create"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.delete"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.import"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.export"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Shift</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.shift.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.shift.read"
                          @change="handlePermissionChangeForRead('shift')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.write"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.create"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.delete"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.import"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.export"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Admin Leaves</td>
                    <!-- <td class="text-center">
                        <label class="custom_check">
                          <input type="checkbox" v-model="permissions.admin_leave.show_navbar" />
                          <span class="checkmark"></span>
                        </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.admin_leave.read"
                          @change="handlePermissionChangeForRead('admin_leave')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.write"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.create"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.delete"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.import"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.export"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Leaves</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.leave.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.leave.read"
                          @change="handlePermissionChangeForRead('leave')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.write"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.create"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.delete"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.import"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.export"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Clients</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.client.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.client.read"
                          @change="handlePermissionChangeForRead('client')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.write"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.create"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.delete"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.import"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.export"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Projects</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.project.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.project.read"
                          @change="handlePermissionChangeForRead('project')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.write"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.create"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.delete"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.import"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.export"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Tasks</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.task.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.task.read"
                          @change="handlePermissionChangeForRead('task')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.write"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.create"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.delete"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.import"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.export"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Teams</td>
                    <!-- <td class="text-center">
                        <label class="custom_check">
                          <input type="checkbox" v-model="permissions.team.show_navbar" />
                          <span class="checkmark"></span>
                        </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.team.read"
                          @change="handlePermissionChangeForRead('team')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.write"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.create"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.delete"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.import"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.export"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Chats</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.chat.show_navbar" />
                        <span class="checkmark"></span>
                      </label> 
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.chat.read"
                          @change="handlePermissionChangeForRead('chat')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.write"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.create"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.delete"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.import"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.export"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Incident</td>
                    <!-- <td class="text-center">
                        <label class="custom_check">
                          <input type="checkbox" v-model="permissions.incident.show_navbar" />
                          <span class="checkmark"></span>
                        </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.incident.read"
                          @change="handlePermissionChangeForRead('incident')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.write"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.create"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.delete"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.import"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.export"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Assets</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.asset.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.asset.read"
                          @change="handlePermissionChangeForRead('asset')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.write"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.create"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.delete"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.import"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.export"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Timing Sheets</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.timing_sheet.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.timing_sheet.read"
                          @change="
                            handlePermissionChangeForRead('timing_sheet')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.write"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.create"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.delete"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.import"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.export"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Overtime</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.overtime.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.overtime.read"
                          @change="handlePermissionChangeForRead('overtime')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.write"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.create"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.delete"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.import"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.export"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Office</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.office.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.office.read"
                          @change="handlePermissionChangeForRead('office')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.write"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.create"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.delete"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.import"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.export"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Organization Documents</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.organization_document.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.organization_document.read"
                          @change="
                            handlePermissionChangeForRead(
                              'organization_document'
                            )
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.write"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.create"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.delete"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.import"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.export"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Employee Report</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.employee_report.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.employee_report.read"
                          @change="
                            handlePermissionChangeForRead('employee_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.write"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.create"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.delete"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.import"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.export"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Daily Report</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.daily_report.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.daily_report.read"
                          @change="
                            handlePermissionChangeForRead('daily_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.write"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.create"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.delete"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.import"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.export"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Attendance Report</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.attendance_report.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.attendance_report.read"
                          @change="
                            handlePermissionChangeForRead('attendance_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.write"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.create"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.delete"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.import"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.export"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Export Attendance</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.export_attendance.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.export_attendance.read"
                          @change="
                            handlePermissionChangeForRead('export_attendance')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.write"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.create"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.delete"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.import"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.export"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Leave Report</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.leave_report.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.leave_report.read"
                          @change="
                            handlePermissionChangeForRead('leave_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.write"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.create"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.delete"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.import"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.export"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Leave Report</td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.time_off_report.read"
                          @change="
                            handlePermissionChangeForRead('time_off_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.write"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.create"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.delete"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.import"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.export"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Leave Setting</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.leave_setting.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.leave_setting.read"
                          @change="
                            handlePermissionChangeForRead('leave_setting')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.write"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.create"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.delete"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.import"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.export"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Global Setting</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.global_setting.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.global_setting.read"
                          @change="
                            handlePermissionChangeForRead('global_setting')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.write"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.create"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.delete"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.import"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.export"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                      </td>
                    </tr>
                    <tr>
                      <td>Roster</td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            v-model="permissions.roster.read"
                            @change="handlePermissionChangeForRead('roster')"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.write"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.create"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.delete"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.import"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.export"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>Tardiness</td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            v-model="permissions.tardiness.read"
                            @change="handlePermissionChangeForRead('tardiness')"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.write"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.create"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.delete"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.import"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.export"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>Leave Calendar</td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            v-model="permissions.leave_calendar.read"
                            @change="handlePermissionChangeForRead('leave_calendar')"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.write"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.create"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.delete"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.import"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.export"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                    </tr>
                </tbody>
              </table>
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Designation Modal -->

  <!-- Edit Designation Modal -->
  <div
    id="edit_designation"
    class="modal custom-modal fade"
    role="dialog"
    ref="editDesignationModal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Position</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="editdesgclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onUpdate">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Position Name <span class="text-danger">*</span></label
              >
              <Field
                name="name"
                type="text"
                value=""
                class="form-control"
                v-model="editform.name"
                :class="{
                  'is-invalid': error?.designation_name
                    ? error.designation_name[0]
                    : '',
                }"
              />
              <div class="invalid-feedback">
                {{ error?.designation_name ? error.designation_name[0] : "" }}
              </div>
              <div class="nameshow text-danger" id="name"></div>
            </div>
            <div class="input-block mb-3">
              <div class="form-check" style="padding-left: 0px">
                <label
                  class="form-check-label"
                  for="customCheck3"
                  style="margin-left: 5px"
                  >Is Reporter ?
                </label>
                <input
                  name="is_reporter"
                  type="checkbox"
                  class="days recurring"
                  id="customCheck3"
                  :value="1"
                  v-model="editform.is_reporter"
                  :checked="editform.is_reporter"
                  style="margin-left: 10px"
                />
                <div class="invalid-feedback">
                  {{ error?.is_reporter ? error.is_reporter[0] : "" }}
                </div>
                <div class="is_reportershow text-danger" id="is_reporter"></div>
              </div>
            </div>
            <div class="input-block mb-3">
              <div class="form-check" style="padding-left: 0px">
                <label
                  class="form-check-label"
                  for="customCheck3"
                  style="margin-left: 5px"
                  >{{ selectAllPermission ? "Deselect All" : "Select All" }}
                </label>
                <input
                  type="checkbox"
                  class="days recurring"
                  id="customCheck3"
                  :value="1"
                  v-model="selectAllPermission"
                  :checked="selectAllPermission"
                  style="margin-left: 10px"
                  @change="handleSelectAllPermission"
                />
              </div>
            </div>
            <div class="">
              <table class="table table-striped custom-table">
                <thead>
                  <tr>
                    <th>Module Permission</th>
                    <!-- <th class="text-center">Show Navbar</th> -->
                    <th class="text-center">Read</th>
                    <th class="text-center">Edit/Update</th>
                    <th class="text-center">Create</th>
                    <th class="text-center">Delete</th>
                    <th class="text-center">Import</th>
                    <th class="text-center">Export</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Holiday</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.holiday.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.holiday.read"
                          @change="handlePermissionChangeForRead('holiday')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.write"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.create"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.delete"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.import"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.holiday.export"
                          :disabled="!permissions.holiday.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Employee</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.employee.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.employee.read"
                          @change="handlePermissionChangeForRead('employee')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.write"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.create"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.delete"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.import"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee.export"
                          :disabled="!permissions.employee.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Face Recognization</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.face_recognization.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.face_recognization.read"
                          @change="
                            handlePermissionChangeForRead('face_recognization')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.write"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.create"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.delete"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.import"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.face_recognization.export"
                          :disabled="!permissions.face_recognization.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Employee BGV</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.emp_bgv.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.emp_bgv.read"
                          @change="handlePermissionChangeForRead('emp_bgv')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.write"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.create"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.delete"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.import"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.emp_bgv.export"
                          :disabled="!permissions.emp_bgv.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Admin Attendance</td>
                    <!-- <td class="text-center">
                        <label class="custom_check">
                          <input type="checkbox"
                          name="rememberme"
                          class="rememberme" v-model="permissions.admin_attendance.show_navbar" />
                          <span class="checkmark"></span>
                        </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.read"
                          @change="
                            handlePermissionChangeForRead('admin_attendance')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.write"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.create"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.delete"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.import"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_attendance.export"
                          :disabled="!permissions.admin_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Attendance</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox"
                        name="rememberme"
                        class="rememberme" v-model="permissions.attendance.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.read"
                          @change="handlePermissionChangeForRead('attendance')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.write"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.create"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.delete"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.import"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance.export"
                          :disabled="!permissions.attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Department</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.department.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.department.read"
                          @change="handlePermissionChangeForRead('department')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.write"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.create"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.delete"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.import"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.department.export"
                          :disabled="!permissions.department.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Position</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.designation.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.designation.read"
                          @change="handlePermissionChangeForRead('designation')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.write"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.create"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.delete"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.import"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.designation.export"
                          :disabled="!permissions.designation.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Wages</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.wages.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.wages.read"
                          @change="handlePermissionChangeForRead('wages')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.write"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.create"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.delete"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.import"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.wages.export"
                          :disabled="!permissions.wages.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Payslip</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.payslip.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.payslip.read"
                          @change="handlePermissionChangeForRead('payslip')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.write"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.create"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.delete"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.import"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.payslip.export"
                          :disabled="!permissions.payslip.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Schedule</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.schedule.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.schedule.read"
                          @change="handlePermissionChangeForRead('schedule')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.write"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.create"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.delete"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.import"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.schedule.export"
                          :disabled="!permissions.schedule.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Shift</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.shift.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.shift.read"
                          @change="handlePermissionChangeForRead('shift')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.write"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.create"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.delete"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.import"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.shift.export"
                          :disabled="!permissions.shift.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Admin Leaves</td>
                    <!-- <td class="text-center">
                        <label class="custom_check">
                          <input type="checkbox" v-model="permissions.admin_leave.show_navbar" />
                          <span class="checkmark"></span>
                        </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.admin_leave.read"
                          @change="handlePermissionChangeForRead('admin_leave')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.write"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.create"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.delete"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.import"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.admin_leave.export"
                          :disabled="!permissions.admin_leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Leaves</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.leave.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.leave.read"
                          @change="handlePermissionChangeForRead('leave')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.write"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.create"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.delete"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.import"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave.export"
                          :disabled="!permissions.leave.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Clients</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.client.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.client.read"
                          @change="handlePermissionChangeForRead('client')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.write"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.create"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.delete"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.import"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.client.export"
                          :disabled="!permissions.client.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Projects</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.project.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.project.read"
                          @change="handlePermissionChangeForRead('project')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.write"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.create"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.delete"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.import"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.project.export"
                          :disabled="!permissions.project.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Tasks</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.task.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.task.read"
                          @change="handlePermissionChangeForRead('task')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.write"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.create"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.delete"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.import"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.task.export"
                          :disabled="!permissions.task.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Teams</td>
                    <!-- <td class="text-center">
                        <label class="custom_check">
                          <input type="checkbox" v-model="permissions.team.show_navbar" />
                          <span class="checkmark"></span>
                        </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.team.read"
                          @change="handlePermissionChangeForRead('team')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.write"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.create"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.delete"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.import"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.team.export"
                          :disabled="!permissions.team.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Chats</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.chat.show_navbar" />
                        <span class="checkmark"></span>
                      </label> 
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.chat.read"
                          @change="handlePermissionChangeForRead('chat')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.write"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.create"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.delete"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.import"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.chat.export"
                          :disabled="!permissions.chat.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Incident</td>
                    <!-- <td class="text-center">
                        <label class="custom_check">
                          <input type="checkbox" v-model="permissions.incident.show_navbar" />
                          <span class="checkmark"></span>
                        </label>
                      </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.incident.read"
                          @change="handlePermissionChangeForRead('incident')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.write"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.create"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.delete"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.import"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.incident.export"
                          :disabled="!permissions.incident.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Assets</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.asset.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.asset.read"
                          @change="handlePermissionChangeForRead('asset')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.write"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.create"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.delete"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.import"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.asset.export"
                          :disabled="!permissions.asset.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Timing Sheets</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.timing_sheet.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.timing_sheet.read"
                          @change="
                            handlePermissionChangeForRead('timing_sheet')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.write"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.create"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.delete"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.import"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.timing_sheet.export"
                          :disabled="!permissions.timing_sheet.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Overtime</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.overtime.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.overtime.read"
                          @change="handlePermissionChangeForRead('overtime')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.write"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.create"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.delete"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.import"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.overtime.export"
                          :disabled="!permissions.overtime.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Office</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.office.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.office.read"
                          @change="handlePermissionChangeForRead('office')"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.write"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.create"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.delete"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.import"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.office.export"
                          :disabled="!permissions.office.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Organization Documents</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.office.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.organization_document.read"
                          @change="
                            handlePermissionChangeForRead(
                              'organization_document'
                            )
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.write"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.create"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.delete"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.import"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.organization_document.export"
                          :disabled="!permissions.organization_document.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Employee Report</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.employee_report.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.employee_report.read"
                          @change="
                            handlePermissionChangeForRead('employee_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.write"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.create"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.delete"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.import"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.employee_report.export"
                          :disabled="!permissions.employee_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Daily Report</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.daily_report.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.daily_report.read"
                          @change="
                            handlePermissionChangeForRead('daily_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.write"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.create"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.delete"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.import"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.daily_report.export"
                          :disabled="!permissions.daily_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Attendance Report</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.attendance_report.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.attendance_report.read"
                          @change="
                            handlePermissionChangeForRead('attendance_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.write"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.create"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.delete"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.import"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.attendance_report.export"
                          :disabled="!permissions.attendance_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Export Attendance</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.export_attendance.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.export_attendance.read"
                          @change="
                            handlePermissionChangeForRead('export_attendance')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.write"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.create"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.delete"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.import"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.export_attendance.export"
                          :disabled="!permissions.export_attendance.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Leave Report</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.leave_report.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.leave_report.read"
                          @change="
                            handlePermissionChangeForRead('leave_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.write"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.create"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.delete"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.import"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_report.export"
                          :disabled="!permissions.leave_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Leave Report</td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.time_off_report.read"
                          @change="
                            handlePermissionChangeForRead('time_off_report')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.write"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.create"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.delete"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.import"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.time_off_report.export"
                          :disabled="!permissions.time_off_report.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Leave Setting</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.leave_setting.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.leave_setting.read"
                          @change="
                            handlePermissionChangeForRead('leave_setting')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.write"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.create"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.delete"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.import"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.leave_setting.export"
                          :disabled="!permissions.leave_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                  <tr>
                    <td>Global Setting</td>
                    <!-- <td class="text-center">
                      <label class="custom_check">
                        <input type="checkbox" v-model="permissions.global_setting.show_navbar" />
                        <span class="checkmark"></span>
                      </label>
                    </td> -->
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          v-model="permissions.global_setting.read"
                          @change="
                            handlePermissionChangeForRead('global_setting')
                          "
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.write"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.create"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.delete"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.import"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td class="text-center">
                      <label class="custom_check">
                        <input
                          type="checkbox"
                          name="rememberme"
                          class="rememberme"
                          v-model="permissions.global_setting.export"
                          :disabled="!permissions.global_setting.read"
                        />
                        <span class="checkmark"></span>
                      </label>
                      </td>
                    </tr>
                    <tr>
                      <td>Roster</td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            v-model="permissions.roster.read"
                            @change="handlePermissionChangeForRead('roster')"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.write"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.create"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.delete"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.import"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.roster.export"
                            :disabled="!permissions.roster.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>Tardiness</td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            v-model="permissions.tardiness.read"
                            @change="handlePermissionChangeForRead('tardiness')"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.write"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.create"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.delete"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.import"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.tardiness.export"
                            :disabled="!permissions.tardiness.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>Leave Calendar</td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            v-model="permissions.leave_calendar.read"
                            @change="handlePermissionChangeForRead('leave_calendar')"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.write"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.create"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.delete"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.import"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                      <td class="text-center">
                        <label class="custom_check">
                          <input
                            type="checkbox"
                            name="rememberme"
                            class="rememberme"
                            v-model="permissions.leave_calendar.export"
                            :disabled="!permissions.leave_calendar.read"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </td>
                    </tr>
                </tbody>
              </table>
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Save</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Designation Modal -->

  <!-- Delete Designation Modal -->
  <div class="modal custom-modal fade" id="delete_designation" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Position</h3>
            <p>Are you sure want to delete?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary continue-btn"
                  @click="deleteDesignation"
                  >Delete</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn"
                  ref="deletedesgclose"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Designation Modal -->
</template>

<script>
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
export default {
  emits: [
    "create-designation",
    "update-designation",
    "delete-designation",
    "reset-errors",
  ],
  components: {
    Form,
    Field,
  },
  props: {
    form: [Array, Object],
    departmentlist: [Array, Object],
    editform: [Array, Object],
    deldes_id: [Number, String],
    error: [Array, Object],
  },
  data() {
    return {
      selectAllPermission: false,
      select2: null,
      Department: [
        "Select Department",
        "Web Development",
        "IT Management",
        "Marketing",
      ],
      permissions: {
        holiday: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        department: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        designation: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        wages: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        payslip: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        schedule: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        shift: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        client: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        project: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        task: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        team: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        chat: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        asset: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        timing_sheet: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        overtime: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        incident: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        office: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        organization_document: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        daily_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        export_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        time_off_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        global_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        face_recognization: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        emp_bgv: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        roster: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        tardiness: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_calendar: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
      },
    };
  },
  methods: {
    handleSelectAllPermission() {
      if (this.selectAllPermission) {
        this.permissions = {
          holiday: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          employee: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          department: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          designation: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          wages: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          payslip: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          schedule: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          shift: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          admin_leave: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          leave: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          client: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          project: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          task: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          team: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          chat: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          asset: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          timing_sheet: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          overtime: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          leave_setting: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          admin_attendance: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          attendance: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          incident: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          office: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          organization_document: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          employee_report: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          daily_report: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          attendance_report: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          export_attendance: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          leave_report: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          time_off_report: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          global_setting: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          face_recognization: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          emp_bgv: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          roster: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          tardiness: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
          leave_calendar: {
            read: true,
            write: true,
            delete: true,
            create: true,
            export: true,
            import: true,
          },
        };
      } else {
        this.defaultPermission();
      }
    },
    defaultPermission() {
      this.permissions = {
        holiday: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        department: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        designation: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        wages: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        payslip: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        schedule: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        shift: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        client: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        project: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        task: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        team: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        chat: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        asset: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        timing_sheet: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        overtime: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        incident: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        office: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        organization_document: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        daily_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        export_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        time_off_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        global_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        face_recognization: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        emp_bgv: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        roster: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        tardiness: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_calendar: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
      };
    },
    handlePermissionChangeForRead(module = null) {
      const readPermission = this?.permissions?.[module]?.read;

      if (!readPermission) {
        if (this.permissions[module].hasOwnProperty('create')) {
          this.permissions[module].create = false;
        }
        if (this.permissions[module].hasOwnProperty('write')) {
          this.permissions[module].write = false;
        }
        if (this.permissions[module].hasOwnProperty('delete')) {
          this.permissions[module].delete = false;
        }
        if (this.permissions[module].hasOwnProperty('import')) {
          this.permissions[module].import = false;
        }
        if (this.permissions[module].hasOwnProperty('export')) {
          this.permissions[module].export = false;
        }
      }
    },
    deleteDesignation() {
      this.$emit("delete-designation", this.deldes_id);
    },
    onSubmit(values) {
      values.permissions = this.permissions;
      values.is_reporter = this.form.is_reporter;
      this.$emit("create-designation", values);
    },
    onUpdate(values) {
      this.editform.permissions = this.permissions;
      this.$nextTick(() => {
        this.$emit("update-designation", this.editform);
      });
    },
    closeDialog() {
      this.resetPermission();
      this.$refs.adddesgclose.click();
      this.$refs.editdesgclose.click();
      this.$refs.deletedesgclose.click();
    },
    resetPermission() {
      this.selectAllPermission = false;
      this.permissions = {
        holiday: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        department: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        designation: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        wages: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        payslip: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        schedule: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        shift: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        client: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        project: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        task: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        team: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        chat: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        asset: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        timing_sheet: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        overtime: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        admin_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        incident: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        office: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        organization_document: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        employee_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        daily_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        attendance_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        export_attendance: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        time_off_report: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        global_setting: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        face_recognization: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        emp_bgv: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        roster: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        tardiness: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
        leave_calendar: {
          read: false,
          write: false,
          delete: false,
          create: false,
          export: false,
          import: false,
        },
      };
    },
    resetForms() {
      this.resetPermission();
      this.$emit("reset-errors");
    },
  },
  watch: {
    editform(newVal) {
      this.selectAllPermission = false;
      if (newVal?.permissions && newVal?.permissions != null) {
        let parsed = {};
        try {
          parsed = JSON.parse(newVal.permissions);
        } catch (e) {
          parsed = {};
        }

        this.permissions = Object.keys(this.permissions).reduce((acc, key) => {
          acc[key] = {
            read: parsed[key]?.read ?? false,
            write: parsed[key]?.write ?? false,
            delete: parsed[key]?.delete ?? false,
            create: parsed[key]?.create ?? false,
            export: parsed[key]?.export ?? false,
            import: parsed[key]?.import ?? false,
          };
          return acc;
        }, {});
      } else {
        this.resetPermission();
      }
    },
  },
  mounted() {
    // const addModal = document.getElementById("add_designation");
    // addModal.addEventListener("hidden.bs.modal", this.resetForms);

    // const editModal = document.getElementById("edit_designation");
    // editModal.addEventListener("hidden.bs.modal", this.resetForms);

    if (this.$refs.addDesignationModal) {
      this.$refs.addDesignationModal.addEventListener(
        "hidden.bs.modal",
        this.resetForms
      );
    }

    if (this.$refs.editDesignationModal) {
      this.$refs.editDesignationModal.addEventListener(
        "hidden.bs.modal",
        this.resetForms
      );
    }
  },
  setup() {
    const schema = Yup.object().shape({
      designation_name: Yup.string().required("Position Name is required"),
    });

    const editschema = Yup.object().shape({
      name: Yup.string().required("Position Name is required"),
    });

    return {
      schema,
      editschema,
    };
  },
};
</script>
